import { FastlyImage } from '@components/common/image'
import { Trans } from '@lingui/macro'

type CodingClassCatalogProps = {
  title?: string | JSX.Element
  description?: string | JSX.Element
}

const CodingClassCatalog = ({
  title,
  description,
}: CodingClassCatalogProps) => {
  return (
    <div className="container mx-auto flex flex-col space-y-10 my-12 lg:my-16 text-grey px-5 ">
      <h2 className="text-2xl lg:text-4xl font-600 lg:mb-3 text-center leading-tight">
        {title ? (
          title
        ) : (
          <Trans id="home.coding-class-catalog.title">
            Our coding class catalog is appropriate for{' '}
            <span className="yellow-underline">
              High School, Middle School, and Elementary school students
            </span>
          </Trans>
        )}
      </h2>
      <div className="flex flex-col items-center lg:flex-row gap-y-10 lg:gap-y-0 lg:gap-x-10 justify-evenly mb-12">
        <FastlyImage
          src="/images/home/student-attending-class.png"
          alt="Students attending coding class"
          webpSrc="/images/home/student-attending-class.webp"
          width={369}
          height={376}
        />

        <div className="lg:text-lg w-full lg:w-3/5 space-y-2 text-center lg:text-left">
          {description ? (
            description
          ) : (
            <Trans id="home.coding-class-catalog.description ">
              <p>
                Our STEM.org-accredited catalog offers a variety of online
                coding classes for kids and teens ages 6-18, designed for every
                skill level. Elementary school learners in Grades 1-3 can begin
                with block-based coding through beginner-friendly drag-and-drop
                platforms such as Scratch and Thunkable. Middle school learners
                in Grades 4-8 can explore web development, Python, Roblox game
                development, and Android app creation. High school learners in
                Grades 9-12 can advance to data science, IOI algorithms, and AP
                Computer Science, building skills for college and future
                careers.
              </p>
              <p>
                Codingal supports learners from ages 6-18 and Grades 1-12
                through engaging, comprehensive coding education that
                strengthens creativity, problem-solving, and critical-thinking
                skills.
              </p>
            </Trans>
          )}
        </div>
      </div>
    </div>
  )
}

export default CodingClassCatalog
